module.exports = __webpack_public_path__ + "img/rowB1.4dc58182.png";